import { Project } from '../types';

export const projects: Project[] = [
    {
      title: "Sistema de Gestión de Pacientes",
      description:
        "Un sistema diseñado específicamente para gestionar y administrar información de pacientes, construido con Vite y React para un rendimiento óptimo en un entorno local.",
      tags: ["Web", "React", "Vite"],
      image: "./images/proyect1.png",
      link: "https://github.com/omarPVP123131/veterinaria",
    },
    {
      title: "Punto de Venta",
      description:
        "Punto de Venta hecho en python con el framework de qt6 y sqlite para una base de datos local",
      tags: ["Desktop", "Python", "Sqlite", "Qt"],
      image: "/images/proyect2.png",
      link: "https://github.com/omarPVP123131/pos-python",
    },
    {
      title: "sistema de punto de venta",
      description:
        "Sistema de Punto De Venta completamente portatil la cual maneja una Api Restful propia la cual permite el enlace a la aplicacion de escritorio",
      tags: ["Multiplataforma", "Flutter", "Dart", "Sqlite", "Python"],
      image: "/images/proyect3.png",
      link: "https://github.com/omarPVP123131/pos",
    },
  ];
